import { render } from "./wallet.vue?vue&type=template&id=bc89cef8&scoped=true"
import script from "./wallet.vue?vue&type=script&lang=js"
export * from "./wallet.vue?vue&type=script&lang=js"

import "./wallet.vue?vue&type=style&index=0&id=bc89cef8&lang=scss&scoped=true"
import "./wallet.vue?vue&type=style&index=1&id=bc89cef8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc89cef8"]])

export default __exports__